import { data } from '../../svg/CheckBox/data';
import { makeIcon } from '../makeIcon';

export const CheckBox = makeIcon(data, 'check_box', 'CheckBox');

export default CheckBox;
